import * as React from 'react';
import Map from '~/components/Map';
import { t } from '~/i18n';
import styled from 'styled-components';
import { Button } from '@watcherr/ui';
import { MapEvent } from '~config/map';
import GeoJSON from 'geojson';

type Props = {
  lat: number;
  long: number;
  polygon?: GeoJSON.Feature<GeoJSON.Polygon>;
  defaultPolygon?: GeoJSON.Feature<GeoJSON.Polygon>;
  onCancel: () => void;
  onSave: (polygon?: GeoJSON.Feature<GeoJSON.Polygon>) => void;
  residentSetting?: boolean,
}

const OutdoorGeofenceEditor: React.FC<Props> = ({ polygon, lat, long, onCancel, onSave, defaultPolygon, residentSetting }) => {
  const geofenceMap = React.useRef<Map>(null);
  const [geo, setGeo] = React.useState<GeoJSON.Feature<GeoJSON.Polygon> | undefined>(polygon);

  const [isDrawing, setIsDrawing] = React.useState(false)

  const handleLoad = (map: Map) => {
    map.listenToEvent(MapEvent.ZoneDrawingCreatedUpdated, geo => {
      setGeo(geo)
      setIsDrawing(false)
    });
    if (polygon) {
      map.sendEvent(MapEvent.SetOutdoorPolygon, polygon)
    }
  }

  const handleSave = () => {
    onSave(geo)
    setIsDrawing(false)
  }

  const handleClear = () => {
    geofenceMap.current?.sendEvent(MapEvent.SetOutdoorPolygon, undefined)
    setGeo(undefined)
    setIsDrawing(false)
  }

  const handleDraw = () => {
    setIsDrawing(true)
    geofenceMap.current?.sendEvent(MapEvent.ZoneDrawCreateDrawingClick, undefined)
  }

  const handleSetDefault = () => {
    if (defaultPolygon) {
      setGeo(defaultPolygon)
      geofenceMap.current?.sendEvent(MapEvent.SetOutdoorPolygon, defaultPolygon)
    }
  }

  return (
    <div>
      <ButtonRow style={{ marginBottom: 5 }}>
        <Row>
          <Button style={{ marginRight: 5 }} disabled={!geo || isDrawing} onClick={handleClear} buttonType="error">
            {t('outdoor-geofence-editor.clear')}
          </Button>
          <Button style={{ marginRight: 5 }} disabled={!!geo || isDrawing} onClick={handleDraw} buttonType="success">
            {t('outdoor-geofence-editor.draw')}
          </Button>
          {residentSetting && <Button disabled={isDrawing || !defaultPolygon || !!geo} onClick={handleSetDefault}>
            {t('outdoor-geofence-editor.load-default')}
          </Button>}

        </Row>
      </ButtonRow>
      <div style={{ height: 500, marginBottom: 15 }}>
        <Map onMapLoaded={handleLoad} page="outdoor-draw-tool" lat={lat} long={long} ref={geofenceMap} height={500} />
      </div>
      <ButtonRow>
        <Row>
        </Row>
        <Row>
          <Button onClick={onCancel} buttonType="link">
            {t('global.cancel')}
          </Button>
          <Button disabled={isDrawing} onClick={handleSave}>
            {t('global.submit')}
          </Button>
        </Row>
      </ButtonRow>
    </div >
  );
};

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Row = styled.div`
  display: flex;
  align-items: center;
`

export default OutdoorGeofenceEditor;
